import React, { memo } from "react";
import Icon from "./Icon";
const MicOff = /*#__PURE__*/memo(props => /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("path", {
  d: "M0.916748 0.916672L21.0834 21.0833"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.75 8.56166V3.66666C13.7507 2.98469 13.4979 2.32679 13.0408 1.82068C12.5837 1.31457 11.9549 0.996361 11.2764 0.927824C10.5979 0.859286 9.91807 1.04531 9.36899 1.44979C8.81991 1.85426 8.44071 2.44833 8.305 3.11666M8.25 8.25V11C8.25048 11.5435 8.41202 12.0748 8.71423 12.5266C9.01643 12.9783 9.44575 13.3304 9.94795 13.5384C10.4501 13.7463 11.0027 13.8008 11.5358 13.6949C12.069 13.589 12.5587 13.3274 12.9433 12.9433L8.25 8.25Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.4168 9.16667V11C17.4164 11.3781 17.3827 11.7554 17.3159 12.1275M15.5834 15.5375C14.6886 16.4509 13.5412 17.0761 12.2886 17.3329C11.0359 17.5897 9.73512 17.4664 8.55305 16.9788C7.37097 16.4912 6.36154 15.6615 5.65425 14.5962C4.94696 13.531 4.57407 12.2787 4.58342 11V9.16667L15.5834 15.5375Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11 17.4167V21.0833"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.33325 21.0833H14.6666"
})));
MicOff.displayname = "MicOff";
export default MicOff;
//# sourceMappingURL=MicOff.js.map